module.exports = __webpack_public_path__ + "img/alerts.d46aabe6.svg";